import ModalContainer from 'components/modal/modal-container'

import ModalActions from 'components/modal/modal-actions'
import { Button } from '@mui/material'

import { closeModal } from 'actions/app'

import { deleteOperator } from 'api/operator'
import { useTranslation } from 'react-i18next'
import type { Operator } from 'store/state/account'
import type { ThunkDispatch } from 'redux-thunk'
import type { UnknownAction } from 'redux'
import type { AppState } from 'state/index'

import { useDispatch } from 'react-redux'

export type DeleteOperatorProps = {
  selectedOperator?: Operator
  selectedOperators?: Operator[]
}

export default function DeleteOperator(props: DeleteOperatorProps) {
  const { t } = useTranslation()
  const dispatch =
    useDispatch<ThunkDispatch<AppState, unknown, UnknownAction>>()
  const { selectedOperator, selectedOperators } = props

  // Support both single and multiple operator deletion
  const operators: Operator[] =
    selectedOperators || (selectedOperator ? [selectedOperator] : [])

  const closePopup = () => dispatch(closeModal())

  const deleteItem = () => {
    operators.forEach((operator) => {
      dispatch(deleteOperator(operator.id))
    })
  }

  const getWarningMessage = () => {
    if (operators.length === 1) {
      return t('delete_item_warning', { name: operators[0].name })
    }
    return t('delete_multiple_item_warning', {
      count: operators.length,
      item: t('operators').toLocaleLowerCase(),
    })
  }

  return (
    <ModalContainer>
      <div>{getWarningMessage()}</div>
      <ModalActions>
        <Button variant="contained" color="secondary" onClick={closePopup}>
          {t('cancel')}
        </Button>
        <Button variant="contained" color="primary" onClick={deleteItem}>
          {t('delete')}
        </Button>
      </ModalActions>
    </ModalContainer>
  )
}
